export default __webpack_public_path__ + "static/media/property_836.774439e1.png";